import axios from 'axios'

const state = {
  userInfo: null
}

const mutations = {
  LOGIN (state, data) {
    state.userInfo = data
  },
  LOGOUT (state) {
    state.userInfo = null
  }
}

const actions = {
  logout ({ commit }) {
    delete localStorage.token
    commit('LOGOUT')
    return axios
      .post('/web/logout')
      // .get('/web/api/member/checkauth')
      .then(resp => {
        return resp.data
      })
  },
  login ({ commit }, token) {
    localStorage.token = token
    return axios
      .get('/web/api/member/checkauth')
      .then(resp => {
        commit('LOGIN', resp.data)
        return resp.data
      })
  }
}

const getters = {
  isAuthenticated: state => {
    return !!state.userInfo
  },
  isCertUser: state => {
    return !!state.userInfo.org_cd
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/auth.js